import MyCampaigns from './my-campaigns';

export default MyCampaigns;
